<span style="padding: 15px;"><strong>Loan Servicing</strong> | Reports/Sanity Checks</span>

<div class="container-fluid" style="height: 90vh; padding: 0">
    <mat-sidenav-container class="reports-sidenav-container" style="height: 100%;">
        <mat-sidenav #sidenav mode="side" [class.mat-elevation-z4]="true" class="reports-sidenav" opened="true"
            disableClose="true">
            <mat-nav-list>
                <mat-list-item [routerLinkActive]="['active-reports-link']" [routerLink]="['ach-checks']" >
                    <span style="display: flex; align-items: center">
                        <mat-icon>playlist_add_check</mat-icon><span class="sideNavSpan">ACH Checks</span>
                    </span>
                </mat-list-item>
                <mat-list-item [routerLinkActive]="['active-reports-link']" [routerLink]="['ach-validation']">
                    <span style="display: flex; align-items: center">
                        <mat-icon>verified_user</mat-icon><span class="sideNavSpan">ACH Validation</span>
                    </span>
                </mat-list-item>
                <mat-list-item [routerLinkActive]="['active-reports-link']" [routerLink]="['balloon-payments']">
                    <span style="display: flex; align-items: center">
                        <mat-icon>payments</mat-icon><span class="sideNavSpan">Balloon Payments</span>
                    </span>
                </mat-list-item>
				<mat-list-item [routerLinkActive]="['active-reports-link']" [routerLink]="['daily-recon']">
					<span style="display: flex; align-items: center">
						<mat-icon>newspaper</mat-icon><span class="sideNavSpan">Daily Recon</span>
					</span>
				</mat-list-item>
                <mat-list-item [routerLinkActive]="['active-reports-link']" [routerLink]="['multiple-status-code']">
                    <span style="display: flex; align-items: center">
                        <mat-icon>content_copy</mat-icon><span class="sideNavSpan">Multiple Status Code</span>
                    </span>
                </mat-list-item>
                <mat-list-item [routerLinkActive]="['active-reports-link']" [routerLink]="['expired-ach']">
                    <span style="display: flex; align-items: center">
                        <mat-icon>hourglass_disabled</mat-icon><span class="sideNavSpan">Expired ACH</span>
                    </span>
                </mat-list-item>
				<mat-list-item [routerLinkActive]="['active-reports-link']" [routerLink]="['zero-balance']">
                    <span style="display: flex; align-items: center">
                        <mat-icon>exposure_zero</mat-icon><span class="sideNavSpan">Zero Balance</span>
                    </span>
                </mat-list-item>
            </mat-nav-list>
        </mat-sidenav>
        <mat-sidenav-content>
            <div (click)="sidenav.toggle(); toggleSideNav()" class="sidenav-toggle-button"
                [ngClass]="isSideNavMenuOpen ? 'sidenav-open' : 'sidenav-closed'">
                <div class="icon-bar" [@sideNavMenuAnimationState]="isSideNavMenuOpen ? 'line' : 'topX'"></div>
                <div class="icon-bar" [@sideNavMenuAnimationState]="isSideNavMenuOpen ? 'line' : 'hide'"></div>
                <div class="icon-bar" [@sideNavMenuAnimationState]="isSideNavMenuOpen ? 'line' : 'bottomX'"></div>
            </div>
            <router-outlet> </router-outlet>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>